module.exports = __webpack_public_path__ + "static/media/usn-logo-large.9048c10b.svg";